import { render } from "./DashboardPatient.vue?vue&type=template&id=64e667a2&scoped=true"
import script from "./DashboardPatient.vue?vue&type=script&lang=ts"
export * from "./DashboardPatient.vue?vue&type=script&lang=ts"

import "./DashboardPatient.vue?vue&type=style&index=0&id=64e667a2&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-64e667a2"

export default script